import { render, staticRenderFns } from "./DataTableLoading.vue?vue&type=template&id=a57acb3c&"
import script from "./DataTableLoading.vue?vue&type=script&lang=js&"
export * from "./DataTableLoading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports